/* eslint-disable no-unused-vars */

const checkValueIsNullUndefinedOrEMpty = ({ value }) => {
  return value !== null && value !== undefined && value !== '' ? true : false;
};
const conversionOfNumber = ({ value, selectedLengthUnit }) => {
  // return Number(value?.toFixed(selectedLengthUnit === 'in' ? 4 : 5));
  return value;
};

export const prepareInspectionCMLForBackend = ({ currentTask, formData, cmlDataList }) => {
  const cmlLists = [];
  // if (currentTask?.hasUTData && currentTask?.hasUTDataDownload) {
  const inspectionId = currentTask?.id;
  const equipmentId = currentTask?.equipmentId;

  for (let cml of cmlDataList) {
    let selectedLengthUnit = cml?.selectedLengthUnit;

    let outsideDiameterValue =
      selectedLengthUnit === 'mm'
        ? cml?.outsideDiameterOnMM.textBoxValue
        : cml?.outsideDiameter.textBoxValue;

    let outsideDiameterUnitValue =
      selectedLengthUnit === 'mm'
        ? cml?.outsideDiameterOnMM.textBoxUnitValue
        : cml?.outsideDiameter.textBoxUnitValue;

    let nominalDiameterValue =
      selectedLengthUnit === 'mm'
        ? cml?.nominalDiameterOnMM.textBoxValue
        : cml?.nominalDiameter.textBoxValue;

    let nominalDiameterUnitValue =
      selectedLengthUnit === 'mm'
        ? cml?.nominalDiameterOnMM.textBoxUnitValue
        : cml?.nominalDiameter.textBoxUnitValue;

    let wallThicknessValue =
      selectedLengthUnit === 'mm'
        ? cml?.wallThicknessOnMM.textBoxValue
        : cml?.wallThickness.textBoxValue;

    let wallThicknessUnitValue =
      selectedLengthUnit === 'mm'
        ? cml?.wallThicknessOnMM.textBoxUnitValue
        : cml?.wallThickness.textBoxUnitValue;

    let tminValue =
      selectedLengthUnit === 'mm' ? cml?.tminOnMM.textBoxValue : cml?.tmin.textBoxValue;

    let tminUnitValue =
      selectedLengthUnit === 'mm' ? cml?.tminOnMM.textBoxUnitValue : cml?.tmin.textBoxUnitValue;

    let obj = {
      equipmentId: equipmentId,
      inspectionId: inspectionId,
      cmlNumber: cml?.cmlNumber,
      component: cml?.component,
      location: cml?.location,
      orientation: cml?.orientation,
      ...(cml?.material && { material: cml?.material }),
      ...(cml?.schedule && { schedule: cml?.schedule }),

      ...(checkValueIsNullUndefinedOrEMpty({ value: outsideDiameterValue }) && {
        outsideDiameter: outsideDiameterValue
      }),
      ...(outsideDiameterUnitValue && {
        outsideDiameterUnit: outsideDiameterUnitValue
      }),

      ...(checkValueIsNullUndefinedOrEMpty({ value: nominalDiameterValue }) && {
        nominalDiameter: nominalDiameterValue
      }),
      ...(nominalDiameterUnitValue && {
        nominalDiameterUnit: nominalDiameterUnitValue
      }),

      ...(checkValueIsNullUndefinedOrEMpty({ value: wallThicknessValue }) && {
        wallThickness: wallThicknessValue
      }),
      ...(wallThicknessUnitValue && {
        wallThicknessUnit: wallThicknessUnitValue
      }),

      ...(checkValueIsNullUndefinedOrEMpty({ value: tminValue }) && {
        tmin: tminValue
      }),
      ...(tminUnitValue && {
        tminUnit: tminUnitValue
      }),

      ...(checkValueIsNullUndefinedOrEMpty({ value: cml?.minReading.textBoxValue }) && {
        currentMinReading: cml?.minReading.textBoxValue
      }),
      ...(cml?.minReading?.textBoxUnitValue && {
        currentMinReadingUnit: cml?.minReading.textBoxUnitValue
      }),

      ...(checkValueIsNullUndefinedOrEMpty({ value: cml?.avgReading.textBoxValue }) && {
        currentAverageReading: cml?.avgReading.textBoxValue
      }),
      ...(cml?.avgReading?.textBoxUnitValue && {
        currentAverageReadingUnit: cml?.avgReading.textBoxUnitValue
      }),

      skipReading: cml?.isSkipped,
      ...(cml?.comments && { comment: cml?.comments }),
      ...(cml?.isCached && cml?.id && { originalEquipmentCmlId: cml?.id })
    };
    cmlLists.push(obj);
  }
  // }
  return cmlLists;
};
